import { render } from "./EmptyOrder.vue?vue&type=template&id=298c350d&scoped=true&ts=true"
import script from "./EmptyOrder.vue?vue&type=script&lang=ts"
export * from "./EmptyOrder.vue?vue&type=script&lang=ts"

import "./EmptyOrder.vue?vue&type=style&index=0&id=298c350d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298c350d"]])

export default __exports__